import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Contact Us"
        description="Contact NextDayRefund.com — Affordable Advertising Solutions LLC. Email, phone, mailing address, and support hours."
        canonical="/contact"
        noIndex={false}
      />
      <Navbar />
      <div className="section-container py-12 max-w-4xl">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-wider text-[#003366] mb-3">Support</div>
          <h1 className="text-4xl font-black text-[#003366] mb-2">Contact Us</h1>
          <p className="text-[#64748B] text-sm">
            Operated by Affordable Advertising Solutions LLC, d/b/a NextDayRefund.com
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
          <div className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-6 flex gap-4">
            <Mail size={22} className="text-[#2ECC71] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-bold text-[#0F172A] mb-1">Email</h2>
              <a href="mailto:support@nextdayrefund.com" className="text-[#003366] hover:underline text-sm" data-testid="contact-email-link">
                support@nextdayrefund.com
              </a>
            </div>
          </div>

          <div className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-6 flex gap-4">
            <Phone size={22} className="text-[#2ECC71] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-bold text-[#0F172A] mb-1">Phone</h2>
              <a href="tel:+18048583074" className="text-[#003366] hover:underline text-sm" data-testid="contact-phone-link">
                (804) 858-3074
              </a>
            </div>
          </div>

          <div className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-6 flex gap-4">
            <MapPin size={22} className="text-[#2ECC71] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-bold text-[#0F172A] mb-1">Mailing Address</h2>
              <p className="text-[#334155] text-sm">
                Affordable Advertising Solutions LLC<br />
                10391 Indale Ct<br />
                Glen Allen, VA 23060
              </p>
            </div>
          </div>

          <div className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-6 flex gap-4">
            <Clock size={22} className="text-[#2ECC71] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-bold text-[#0F172A] mb-1">Hours</h2>
              <p className="text-[#334155] text-sm">
                Monday&ndash;Friday, 9 AM&ndash;5 PM Eastern<br />
                We reply within 1 business day.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-10">
          <p className="text-[#0F172A] font-semibold mb-2">Billing question?</p>
          <p className="text-[#334155] text-sm">
            Charges appear on your card statement as <strong>NEXTDAYREFUND</strong>. Contact us before disputing a
            charge with your bank &mdash; we'll resolve it quickly. See our{" "}
            <Link to="/refund-policy" className="text-[#003366] font-semibold hover:underline" data-testid="contact-refund-policy-link">
              Refund Policy
            </Link>{" "}
            for details.
          </p>
        </div>

        <div className="text-center pt-4 pb-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Link to="/refund-policy" className="text-[#003366] font-semibold hover:underline" data-testid="contact-view-refund-link">
            Refund Policy
          </Link>
          <Link to="/terms" className="text-[#003366] font-semibold hover:underline" data-testid="contact-view-terms-link">
            Terms &amp; Conditions
          </Link>
          <Link to="/privacy" className="text-[#003366] font-semibold hover:underline" data-testid="contact-view-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/" className="text-[#64748B] hover:underline" data-testid="back-home-from-contact">
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
